import React from 'react';
import { DynamoDBItemWithRelease } from '../types';
import { TASK_STATES } from '../constants';
import EnvelopesSummary from './EnvelopesSummary';

// ─── Types ────────────────────────────────────────────────────────────────────

interface ProductionSummaryProps {
    task: DynamoDBItemWithRelease;
    locked?: boolean;
}

// ─── Component ────────────────────────────────────────────────────────────────

const ReleaseSummary: React.FC<ProductionSummaryProps> = ({ task, locked = false }) => {
    return (
        <EnvelopesSummary
            title="Release Summary"
            envelopes={task.release_data?.envelopes || []}
            taskState={task.state}
            locked={locked}
            lockedMessage="Complete Human Validation to unlock release deployment."
            emptyMessage="Release data will be available once the human validation is completed."
            runningState={TASK_STATES.RELEASE_RUNNING}
            completedState={TASK_STATES.RELEASE_COMPLETED}
        />
    );
};

export default ReleaseSummary;
